/*
 * @Author: zhangb
 * @Date: 2022-05-17 11:16:14
 * @Description:考试中心
 */
import { fetchPost, fetchGet, fetchPut, fetchDel } from '@/axios';
const KnowledgeCenter = {
    getHotPrompts () {
        return fetchGet('/api/message/assistant/hot-prompts');
    },
    getAskMeAnything (prompt) {
        return fetchGet(`/api/message/assistant/ask-me-anything?prompt=${prompt}`);
    },
    postChat (chats) {
        return fetchPost(`/api/message/assistant/post-chat`, chats);
    },
    summaryPrompt (prompt) {
        if (prompt && prompt.length > 10) {
            return fetchGet(`/api/message/assistant/summary?prompt=${prompt}`);
        } else {
            return {'data': prompt};
        }
    },
    accounting (length) {
        return fetchPost(`/api/message/assistant/accounting`, {'length': length});
    },
    uploadChats (chats) {
        return fetchPost(`/api/message/assistant/upload-chats`, chats);
    },
    downloadChats () {
        return fetchGet(`/api/message/assistant/download-chats`);
    },
    getPrompts (page = 0, tenant) {
        return fetchGet(`/api/message/assistant/prompts?page=${page}&tenantId=${tenant}`);
    },
    addPrompt (prompt) {
        /** {
            "tenantId": 0,
            "title": "",
            "prompt": ""
        } */
        return fetchPost(`/api/message/assistant/tenant-prompt`, prompt);
    },
    deletePrompt (id) {
        return fetchDel(`/api/message/assistant/prompt/${id}`);
    },   
    

};
export default KnowledgeCenter;



// WEBPACK FOOTER //
// ./src/services/KnowledgeCenter.js